var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDialogues(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dialogues"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.16667 14.1667L6.60395 16.7614C6.24649 17.1233 6.06775 17.3043 5.91413 17.3171C5.78084 17.3281 5.65035 17.2746 5.5633 17.173C5.46296 17.056 5.46296 16.8016 5.46296 16.2929V14.993C5.46296 14.5366 5.08923 14.2064 4.63767 14.1403V14.1403C3.54479 13.9802 2.68648 13.1219 2.5264 12.029C2.5 11.8488 2.5 11.6338 2.5 11.2037V7.33333C2.5 5.9332 2.5 5.23313 2.77248 4.69835C3.01217 4.22795 3.39462 3.8455 3.86502 3.60581C4.3998 3.33333 5.09987 3.33333 6.5 3.33333H12.6667C14.0668 3.33333 14.7669 3.33333 15.3016 3.60581C15.772 3.8455 16.1545 4.22795 16.3942 4.69835C16.6667 5.23313 16.6667 5.9332 16.6667 7.33333V10.8333M10.8333 10.4167V15.8333M12.6667 11.6667V15M14.1667 10.0515V16.25M15.8333 12.0833V14.1667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogues);
export default __webpack_public_path__ + "static/media/Dialogues.632b8482756961b6dfd0d0b87a4caeb3.svg";
export { ForwardRef as ReactComponent };